import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';
import OrdersListItem from 'app/main/modules/orders/OrdersListItem';
import ProjectsListItem from 'app/main/modules/projects/ProjectsListItem';
import WorkReportsListItem from 'app/main/modules/workreports/WorkReportsListItem';

import ContractsDetailsTab from './tabs/ContractsDetailsTab';
import ContractsLinesTab from './tabs/ContractsLinesTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <ContractsDetailsTab {...props} />
	},
	{
		id: 'lines',
		title: 'MODULE_CONTRACTS_LINES_NAME',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model, updateRefresh, refresh }) => (
			<ContractsLinesTab contract={model} updateRefresh={updateRefresh} />
		)
	},
	{
		id: 'orders',
		title: 'MODULE_ORDERS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('orders') || authorizer.cannot('view', 'orders'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="orders"
				content={{ type: 'list', itemLayout: OrdersListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'ords_cntr_uid', filt_clause: 'equals', filt_value: model.cntr_uid }]}
			/>
		)
	},
	{
		id: 'projects',
		title: 'MODULE_PROJECTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('projects') || authorizer.cannot('view', 'projects'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="projects"
				content={{ type: 'list', itemLayout: ProjectsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'proj_cntr_uid', filt_clause: 'equals', filt_value: model.cntr_uid }]}
			/>
		)
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'acti_cntr_uid', filt_clause: 'equals', filt_value: model.cntr_uid }]}
			/>
		)
	},
	{
		id: 'workreports',
		title: 'MODULE_WORKREPORTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('workreports') || authorizer.cannot('view', 'workreports'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="workreports"
				content={{ type: 'list', itemLayout: WorkReportsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'wore_cntr_uid', filt_clause: 'equals', filt_value: model.cntr_uid }]}
			/>
		)
	}
];

export default tabs;
